import { api } from './requestGraphql'

const getAnswerFromDuckdbRag = async ({ threadId = null, userEmail, question }) => {
    try {
        const res = await api.post('', {
            query: `
        query($threadId: Int, $userEmail: String!, $question: String!) {
          getAnswerFromDuckdbRag(threadId: $threadId, userEmail: $userEmail, question: $question) {
            sql
            answer
            threadId
            metadata {
              rowCount
              executedAt
              success
              error
            }
          }
        }
      `,
            variables: {
                threadId,
                userEmail,
                question
            }
        })

        return res.data.data.getAnswerFromDuckdbRag
    } catch (e) {
        console.error('getAnswerFromDuckdbRag error:', e)
        return null
    }
}

const getThreadMessages = async (threadId, userEmail) => {
    try {
        const res = await api.post('', {
            query: `
        query($threadId: Int!, $userEmail: String) {
          getThreadMessages(threadId: $threadId, userEmail: $userEmail) {
            role
            content
            createdAt
          }
        }
      `,
            variables: {
                threadId,
                userEmail
            }
        })

        return res.data.data.getThreadMessages
    } catch (e) {
        console.error('getThreadMessages error:', e)
        return []
    }
}

const getThreads = async (userEmail) => {
    try {
        const res = await api.post('', {
            query: `
        query($userEmail: String) {
          getThreads(userEmail: $userEmail) {
            thread_id
            user_email
            created_at
            thread_title
          }
        }
      `,
            variables: {
                userEmail
            }
        })

        return res.data.data.getThreads
    } catch (e) {
        console.error('getThreads error:', e)
        return []
    }
}
const deleteThread = async (threadId) => {
    try {
        const res = await api.post('', {
            query: `
        mutation($threadId: Int!) {
          deleteThread(threadId: $threadId)
        }
      `,
            variables: { threadId }
        })
        return res.data.data.deleteThread
    } catch (e) {
        console.error('deleteThread error:', e)
        return false
    }
}

export default {
    getAnswerFromDuckdbRag,
    getThreadMessages,
    getThreads,
    deleteThread
}
